import styled from 'styled-components';
import HappyFreeWifi from './happyFreeWifi.svg';

const HappyFreeWifiIcon = styled(HappyFreeWifi as JSX.Element)`
  width: ${props => props.width || '3rem'};
  height: ${props => props.height || '3rem'};
  margin: ${props => props.margin};
  g {
    path:last-child {
      fill: ${props => props.fill || props.theme.colors.ash.base};
    }
  }
`;

export default HappyFreeWifiIcon;
